export interface FahrzeugscheinFelder {
  kennzeichen: string;
  fin: string;
  halter: string;
  erstzulassung: string;
  hsn: string;
  tsn: string;
}

export interface UnfallberichtFelder {
  unfallDatum: string;
  unfallOrt: string;
  fahrerGegner: string;
  kennzeichenGegner: string;
  versicherungGegner: string;
  vsNummerGegner: string;
}

export const MOCK_FAHRZEUGSCHEIN_FELDER: FahrzeugscheinFelder = {
  kennzeichen: 'MK-TK 1234',
  fin: 'WBA3A9G50ENP25985',
  halter: 'Max Mustermann',
  erstzulassung: '2021-03-15',
  hsn: '0005',
  tsn: 'ACE',
};

export const MOCK_UNFALLBERICHT_FELDER: UnfallberichtFelder = {
  unfallDatum: '2024-03-15',
  unfallOrt: 'Hauptstraße 12, 58640 Iserlohn',
  fahrerGegner: 'Hans Meier',
  kennzeichenGegner: 'MK-HM 999',
  versicherungGegner: 'ADAC Versicherung',
  vsNummerGegner: 'VS-123456789',
};

export function parseFahrzeugscheinOcrResponse(raw: Record<string, unknown>): FahrzeugscheinFelder {
  return {
    kennzeichen: raw.kennzeichen != null ? String(raw.kennzeichen) : '',
    fin: raw.fin != null ? String(raw.fin) : '',
    halter: raw.halter != null ? String(raw.halter) : '',
    erstzulassung: raw.erstzulassung != null ? String(raw.erstzulassung) : '',
    hsn: raw.hsn != null ? String(raw.hsn) : '',
    tsn: raw.tsn != null ? String(raw.tsn) : '',
  };
}

export function parseUnfallberichtOcrResponse(raw: Record<string, unknown>): UnfallberichtFelder {
  return {
    unfallDatum: raw.unfallDatum != null ? String(raw.unfallDatum) : '',
    unfallOrt: raw.unfallOrt != null ? String(raw.unfallOrt) : '',
    fahrerGegner: raw.fahrerGegner != null ? String(raw.fahrerGegner) : '',
    kennzeichenGegner: raw.kennzeichenGegner != null ? String(raw.kennzeichenGegner) : '',
    versicherungGegner: raw.versicherungGegner != null ? String(raw.versicherungGegner) : '',
    vsNummerGegner: raw.vsNummerGegner != null ? String(raw.vsNummerGegner) : '',
  };
}

// ─── Führerschein OCR ─────────────────────────────────────────────────────────

export interface FuehrerscheinVorderseiteFelder {
  nachname: string;
  vorname: string;
  geburtsdatum: string;
  gueltigkeitsdatum_b: string;
  fuehrerschein_nr: string;
}

export interface FuehrerscheinKlasse {
  klasse: string;
  ausstellungsdatum: string;
}

export interface FuehrerscheinRueckseiteFelder {
  klassen: FuehrerscheinKlasse[];
}

export function parseFuehrerscheinOcrResponse(
  seite: 'vorderseite',
  raw: Record<string, unknown>,
): FuehrerscheinVorderseiteFelder;
export function parseFuehrerscheinOcrResponse(
  seite: 'rueckseite',
  raw: Record<string, unknown>,
): FuehrerscheinRueckseiteFelder;
export function parseFuehrerscheinOcrResponse(
  seite: 'vorderseite' | 'rueckseite',
  raw: Record<string, unknown>,
): FuehrerscheinVorderseiteFelder | FuehrerscheinRueckseiteFelder {
  if (seite === 'vorderseite') {
    return {
      nachname: raw.nachname != null ? String(raw.nachname) : '',
      vorname: raw.vorname != null ? String(raw.vorname) : '',
      geburtsdatum: raw.geburtsdatum != null ? String(raw.geburtsdatum) : '',
      gueltigkeitsdatum_b: raw.gueltigkeitsdatum_b != null ? String(raw.gueltigkeitsdatum_b) : '',
      fuehrerschein_nr: raw.fuehrerschein_nr != null ? String(raw.fuehrerschein_nr) : '',
    };
  }

  const rawKlassen = Array.isArray(raw.klassen) ? raw.klassen : [];
  const klassen: FuehrerscheinKlasse[] = rawKlassen
    .filter((k): k is Record<string, unknown> => k != null && typeof k === 'object' && typeof (k as Record<string, unknown>).klasse === 'string' && String((k as Record<string, unknown>).klasse).length > 0)
    .map(k => ({
      klasse: String(k.klasse),
      ausstellungsdatum: k.ausstellungsdatum != null ? String(k.ausstellungsdatum) : '',
    }));

  return { klassen };
}

export function hatKlasseB(klassen: FuehrerscheinKlasse[]): boolean {
  return klassen.some(k => k.klasse === 'B');
}
